import React from 'react'
import SVG from 'react-svg-inline'

const RedTheater = () =>
  <div>
    <section className="container full">
      <div className="col-12-of-12">
        <img src={require('img/red-theater/read_theater_performance.jpg')} alt="Red Theater" />
      </div>
    </section>
    <section className="container">
      <div className="client-quote">
        <blockquote>
          It’s a small private Art Nouveau theater where also great artists have performed, which aims to retrieve its glorious past welcoming who want to trample on its stage. <br/>
          A physical place that becomes also virtual, in order to expand exponentially its boards sharing them with a near and far community. <br/>
          A place of physical and virtual meeting devoted to artists and enthusiasts from every place with common love for music and the visual arts. <br/>
        </blockquote>
      </div>
    </section>
    <section className="container full split-view m-tb-m">
      <aside className="content">
        <h3>Theater performances</h3>
        <h4 style={{ marginBottom: "20px"}}>
        RedTheater - Performing Arts Factory organizes shows in its own little private theater to promote emerging artists. <br/>
        Then these contents are shared on the web to reach a wider audience. <br/>
        Redtheater - Performing Arts Factory is a physical and virtual meeting place for artists and fans of music and visual arts.
        </h4>
      </aside>
      <aside>
        <iframe width="100%" height="220" src="https://www.youtube.com/embed/mmZ0uUFtlCY" frameBorder="0" allowFullScreen></iframe>
      </aside>
    </section>
    
    <section className="container">
      <div className="client-quote">
        <blockquote>
        The Factory's philosophy is based on the voluntary participation: those who collaborate in the project donate time, activities and free credits; they receive in exchange other free credits as meeting opportunity, artistic emotions, inspiration and much more.
        </blockquote>
      </div>
    </section>
    <section className="container">
      <div className="col-12-of-12">
      <iframe width="100%" height="315" src="https://www.youtube.com/embed/TKx453N1uxU" frameBorder="0" allowFullScreen></iframe>
      </div>
    </section>
  </div>

export default RedTheater



// WEBPACK FOOTER //
// src/javascripts/clients/RedTheater.js